// EMP 통합 Sign in 페이지에서만 사용하기 위한 스크립트

// LGEIN-239 Start
function ggStartApp() {
	gapi.load('auth2', function(){
		// Retrieve the singleton for the GoogleAuth library and set up the client.
		auth2 = gapi.auth2.init({
			client_id: ggOptions.appId+'.apps.googleusercontent.com',
			scope: 'profile'
		});
	});
};
// LGEIN-239 End

$(document).ready(function(){

	if(!!document.querySelector('.common-sign-in-area')) {
		if ( document.domain !== 'localhost' ){
			// CORS
			document.domain = 'lg.com';
		}
	} else {
		return false;
	}

	// LGEUK-75 : 20200717 add 
	const countryCode = $('html').data('countrycode').toUpperCase();
	let cookieA = false;
	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}	
	// - LGEUK-75 : 20200717 add

	// SNS Signin 실행
	const snsSignin = {
		snsBtns : null,
		snsData : {
			emailAddr: null,
			snsId: null,
			snsName: null,
			snsType: null,
			snsFlag: 'Y',
			accessToken: null,
			busToken: null,
			registredUrl: null,
			windowUrl: null,
			authorizeKey : null
		},
		empMultiCountryFlag : 'N',
		empMultiCountryCode : '',
		tdClientIDCookie: null,
		tdGlobalID: null,
		tdSscID: null,
		getCookieTd: null,
		init : function() {
			this.snsBtns = $('.sns-area .btn-area .btn, .sns-area .btn-ico button');
			this.addEvent();
		},
		addEvent: function() { // 각 SNS 버튼 클릭시 trySocialLogin 실행
			this.snsBtns.on('click', $.proxy(this.trySocialLogin, this));
		},
		trySocialLogin: function( event ) { // SNS별로 try~~함수 실행 (쿠키값이 N이거나 특정 국가인지 체크)
			
			const $btn = $(event.currentTarget);

			// 쿠키값이 N이거나 특정 지정 국가면 로그인 안됨.
			if(cookieA || treasureDataFlag != 'Y'){ // LGEITF-182

				// 버튼별 URL 확인
				this.snsData.registredUrl = $btn.data('url');
				this.snsData.windowUrl =$btn.data('windowUrl');

				// SNS Type 확인
				if($btn.hasClass('btn-fb')) {
					this.snsData.snsType = "FACEBOOK";
				} else if($btn.hasClass('btn-gg')) {
					this.snsData.snsType = "GOOGLE";
				} else if($btn.hasClass('btn-apple')) {
					this.snsData.snsType = "APPLE";
				} else if($btn.hasClass('btn-amazon')) {
					this.snsData.snsType = "AMAZON";
				}

				// SNS 종류별로 실행
				switch(this.snsData.snsType) {
					case "FACEBOOK":
						this.tryFacebook();
						break;
					case "GOOGLE":
						this.tryGoogle();
						break;
					case "APPLE":
						this.tryApple();
						break;
					case "AMAZON":
						this.tryAmazon();
						break;
				}

			}else{
				ePrivacyCookies.view('click');
			}

		},
		tryFacebook: function() { // facebook
			// LGEUK-75 Start 
			FB.login(function(response) {
				snsSignin.snsData.accessToken = response.authResponse.accessToken || "";
				if (response.status === 'connected') {   // Logged into your webpage and Facebook.
					FB.api('/me', {fields:'email, name, token_for_business'}, function(response) {				
						snsSignin.snsData.emailAddr = response.email || "";
						snsSignin.snsData.snsId =  response.id || "";
						snsSignin.snsData.snsName =  response.name || "";
						snsSignin.snsData.busToken =  response.token_for_business || "";
						snsSignin.runLoginAPI();
					});			
				} else { 
				}
			}, {scope: 'public_profile,email'});
			// LGEUK-75 End
		},
		tryGoogle: function() { // google 
			// LGEIN-239 Start
			const gauth = gapi.auth2.getAuthInstance();
					
			// 구글로그인 성공
			gauth.signIn().then(function(response){
				const profile = gauth.currentUser.get().getBasicProfile();
				var gAccessToken = gauth.currentUser.get().getAuthResponse(true).access_token;
				snsSignin.snsData.emailAddr = profile.getEmail() || "";
				snsSignin.snsData.snsId =  profile.getId() || "";
				snsSignin.snsData.snsName =  profile.getName() || "";
				snsSignin.snsData.accessToken =  gAccessToken || "";
				snsSignin.runLoginAPI();
			});
			// LGEIN-239 End
		},
		tryApple: function() { // apple
			AppleID.auth.init(window.appleOptions);
			AppleID.auth.signIn(); //로그인창 실행 
			document.addEventListener('AppleIDSignInOnSuccess', function(data){
				let appleToken = data.detail.authorization.id_token;
				let appleResult = JSON.parse(appleDecoder(appleToken.split(".")[1]));
				snsSignin.snsData.emailAddr = appleResult.email || "";
				snsSignin.snsData.snsId = appleResult.sub || "";
				snsSignin.snsData.snsName = appleResult.Name || "";
				snsSignin.snsData.accessToken = appleToken || "";
				snsSignin.runLoginAPI();
			});
		},
		tryAmazon: function() { // amazon
			const authorizeOpt =  {
				scope: 'profile',
				pkce : true
			};
			amazon.Login.authorize(authorizeOpt, function(response) {
				if(response.error) {
					return false;
				}
				amazon.Login.retrieveToken(response.code, function(response) {
					if ( response.error ) {
						return false;
					}
					snsSignin.snsData.accessToken = response.access_token || "";
					amazon.Login.retrieveProfile(response.access_token, function(response) {
						snsSignin.snsData.emailAddr = response.profile.PrimaryEmail || "";
						snsSignin.snsData.snsId = response.profile.CustomerId || "";
						snsSignin.snsData.snsName = response.profile.Name || "";
						snsSignin.runLoginAPI();
					});
				});
			});
		},
		runLoginAPI: function() { // 각 SNS try~~ 함수에서  로그인 성공시 loginAPI 를 실행
			this.loginAPI({
				emailAddr : this.snsData.emailAddr,
				snsId : this.snsData.snsId,
				snsName : this.snsData.snsName,
				snsType : this.snsData.snsType,
				snsFlag : this.snsData.snsFlag,
				accessToken : this.snsData.accessToken,
				busToken : this.snsData.busToken,
				registredUrl : this.snsData.registredUrl,
				windowUrl : this.snsData.windowUrl
			});
		},
		loginAPI: function( options ) { // registredUrl 에 ajax 호출하여, 성공시 afterSocialLogin 실행
			const url = options.registredUrl;
			snsSignin.empMultiCountryFlag = $(document).find('[name="empMultiCountryFlag"]').val();
			var countryCodeCheckbox = document.getElementById("countryCode"); 
			snsSignin.empMultiCountryCode = snsSignin.empMultiCountryFlag == 'Y'? countryCodeCheckbox.options[countryCodeCheckbox.selectedIndex].value : "";
			const data = {
				emailAddr : options.emailAddr,
				snsId : options.snsId,
				snsName: options.snsName,
				snsType : options.snsType,
				snsFlag : options.snsFlag,
				accessToken : options.accessToken,
				busToken : options.busToken,
				treasureType : 'login', // LGEITF-182
				tdloginType : 'social', // LGEITF-182
				authorizeKey : snsSignin.getSsoURLParams(location.href).authorizeKey,
				empMultiCountryFlag : snsSignin.empMultiCountryFlag,
				empMultiCountryCode : snsSignin.empMultiCountryCode
			};
			$.ajax({
				type:"post",
				url : url,
				data : data,
				async: false,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success : snsSignin.afterSocialLogin,
				error: function( request, status, error ) {
					console.log("status: "+status);
					console.log("error: "+error);
				}
			});
		},
		// afterSocialLogin : 
		// - 연결 불가시 
		// ---- error.code가 1010이면 연결불가 메시지 출력
		// ---- 아니면, tdFailUrl 호출후 treasuredataInit(failData,'FAIL'); 실행하고, 중복체크 윈도팝업 띄움
		// - 연결 가능시
		// ---- EMP 통합이 필요하면 통합 페이지로 이동
		// ---- 정책 재동의가 필요하면 해당 레이어팝업 띄움
		// ---- 아니면,  쿠키동의에 따라 treasuredataInit(resultData, 'loginAPI') 실행하거나 signinByIDPW 이벤트 실행
		afterSocialLogin: function( resultData ) {
			const phase = {
				EMAIL_DUPLICATE : "phase1", 
				LOG_IN : "phase2" 
			};
			const status = resultData.status === "fail" ? phase['EMAIL_DUPLICATE'] : phase['LOG_IN'];
			switch(status){
				// Not Registred
				case phase['EMAIL_DUPLICATE']:
					// escape:already token abroad
					const isWhereAlreadyAbroad = resultData.error.code === "1010";
					if(isWhereAlreadyAbroad){
						// 메시지 창 띄움 - You cannot connect with social account that is being used abroad.
						const modalID = "duplicateSnsToken";
						return $("#" + modalID).modal("show");
					};

					// LGEITF-182, LGEGMC-4064 Start > TreasureDataInsert 스크립트로 인해 조건변경
					if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
						let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
						if(window.location.href.indexOf('/oauth/') >=0) {
							const actionURL = ($('#signinForm').data('action-url').length>0) ? $('#signinForm').data('action-url') : null;
							if(actionURL.indexOf('wdev50.lg.com')>=0) {
								tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
							} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
								tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
							} else if(actionURL.indexOf('www.lg.com')>=0){
								tdFailUrl="https://www.lg.com"+tdFailUrl;
							}else{
								tdFailUrl="https://"+window.location.host+tdFailUrl;
							}
						}
						$.ajax({
							type: 'post',
							url: tdFailUrl,
							dataType: 'json',
							data: {
								emailAddr : snsSignin.snsData.emailAddr,
								snsId : snsSignin.snsData.snsId,
								snsName : snsSignin.snsData.snsName,
								snsType : snsSignin.snsData.snsType,
								snsFlag : snsSignin.snsData.snsFlag,
								treasureType : 'login',
								tdloginType : 'social'
							},
							xhrFields: {
								withCredentials: true
							},
							async: false,
							success: function( failData ) {
								if(resultData.error.tdMessage){
									failData["failMessage"]=resultData.error.tdMessage;
								}else{
									failData["failMessage"]=resultData.error.message;
								}
								if(resultData.error.tdTypeFail){
									failData["tdTypeFail"]=resultData.error.tdTypeFail;
								}
								snsSignin.treasuredataInit(failData,'FAIL');
							},
							error: function( request, status ,error ) {
								console.log("status: "+status);
								console.log("error: "+error);
							}
						});
					//LGCOMITF-123-2 start
					} else if ( cookieA ) {
						let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
						if(window.location.href.indexOf('/oauth/') >=0) {
							const actionURL = ($('#signinForm').data('action-url').length>0) ? $('#signinForm').data('action-url') : null;
							if(actionURL.indexOf('wdev50.lg.com')>=0) {
								tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
							} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
								tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
							} else if(actionURL.indexOf('www.lg.com')>=0){
								tdFailUrl="https://www.lg.com"+tdFailUrl;
							}else{
								tdFailUrl="https://"+window.location.host+tdFailUrl;
							}
						}
						$.ajax({
							type: 'post',
							url: tdFailUrl,
							dataType: 'json',
							data: {
								emailAddr : snsSignin.snsData.emailAddr,
								snsId : snsSignin.snsData.snsId,
								snsName : snsSignin.snsData.snsName,
								snsType : snsSignin.snsData.snsType,
								snsFlag : snsSignin.snsData.snsFlag,
								treasureType : 'login',
								tdloginType : 'social'
							},
							xhrFields: {
								withCredentials: true
							},
							async: false,
							success: function( failData ) {
								if(resultData.error.tdMessage){
									failData["failMessage"]=resultData.error.tdMessage;
								}else{
									failData["failMessage"]=resultData.error.message;
								}
								if(resultData.error.tdTypeFail){
									failData["tdTypeFail"]=resultData.error.tdTypeFail;
								}
								snsSignin.nonTreasureDataInsertTable(failData);
							},
							error: function( request, status ,error ) {
								console.log("status: "+status);
								console.log("error: "+error);
							}
						});
					}
					// LGEITF-182, LGEGMC-4064 End, LGCOMITF-123-2 end 
					
					// Email 중복체크 윈도팝업 실행
					const openinfo = {
						name : "signinWin",
						url : resultData.windowUrl,
						width : 480,
						height : 650
					}
					// openWin 함수 common.js 에 존재함
					openWin(openinfo.url, openinfo.name, openinfo.width, openinfo.height);
					break;
				// Registred
				case phase['LOG_IN']:
					// escape:account intergration
					const notYetIntergration = resultData.combineProgressFlag === "Y" ? true : false;
					if(notYetIntergration){
						var inteSnsId = snsSignin.snsData.snsType === "FACEBOOK" ? snsSignin.snsData.busToken : snsSignin.snsData.snsId;
						return snsSignin.pageGoPost({
		                    url : resultData.combineProgressUrl,
		                    target : "_self",
		                    vals : [
		                        ["snsId", 		 inteSnsId],
		                        ["accessToken",  snsSignin.snsData.accessToken],
		                        ["snsLoginType", resultData.snsLoginType],
		                        ["accessKey",    resultData.accessKey]
		                    ]
		                });
					}
					// escape:update policy
					const isUpdatePolicy = resultData.privacyReconsentFlag === "Y" ? true : false;
					if(isUpdatePolicy){
						var responEmail = resultData.data.user.emailAddr;
						$.ajax({
    						url : resultData.privacyReconsentUrl,
    						data : {
    							empSid : resultData.data.user.empLoginSessionID,
    							countryCode : resultData.data.user.empCountryCode,
    							reConsentTerms : resultData.reConsentTerms,
    							empCustomerNo : resultData.data.user.mbrNo,
    							customerNo : resultData.data.user.userId,
    							emailAddr : resultData.data.user.emailAddr
    						},
    						async : false,
    						contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
    						xhrFields : {
    							withCredentials : true
    						},
    						success : function(data){
    							$('#signinForm').find('input[name=emailAddr]').val(responEmail);
    							$('#signinForm').find('input[name=submitData]').val(JSON.stringify(resultData));
    							$('#modal_policy_again_emp').html(data);
    						},
    						error : console.log("error"),
    						complete: function(){
    							jQuery.snsSignInRepolicyCall();
    						}
    					});
						$('#modal_policy_again_emp').modal('show');
						return;
					}
					// sign in 
					resultData.snsFlag = snsSignin.snsData.snsFlag;
					resultData.snsName = snsSignin.snsData.snsName;
					resultData.snsId = snsSignin.snsData.snsId;
					resultData.snsType = snsSignin.snsData.snsType;
					resultData.accessToken = snsSignin.snsData.accessToken;
					resultData.busToken = snsSignin.snsData.busToken;
					
					//LGEGMC-4064 start treasureDataInsert 스크립트로 인해 조건변경
					if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
						snsSignin.treasuredataInit(resultData, 'loginAPI');
					}else{
						//LGCOMITF-123-2 stat
						if ( cookieA ) {
							snsSignin.nonTreasureDataInsertTable(resultData);
						}
						//LGCOMITF-123-2 end
						snsSignin.signinByIDPW(resultData);
					}
					//LGEGMC-4064 End
					break;
			}
		},
		signinByIDPW: function( resultData ) { //  id pw 방식으로 로그인 (기존 snsLogin 이벤트)

			// 기존 쿠키 재동의 에러 코드가 1008 인듯?? 
			// 여기서 다시 확인해야 하는 이유가 있을까? 
			//const isUpdatePolicy = resultData.privacyReconsentFlag === "Y" ? true : false;
			//if(isUpdatePolicy){
			//	return this.popModalPolicyAgree();
			//}

			const signinForm = document.getElementById('signinForm'); 
			var $emailAccount = $(signinForm).find('[name="emailAddr"]');
			var $submitInput = $(signinForm).find('[name="submitData"]');
			$emailAccount.val( resultData.emailAddr );
			$submitInput.val( JSON.stringify( resultData ) );

			// adobe
			adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
			// LGEGMC-3469 Start
			if(salesForceUseFlag || salesForceUseFlagV2){ // LGEGMC-5141
				console.log('ecrmLogined insert');
				SalesforceInteractions.sendEvent({
					interaction: {
						name: 'ecrmLogined',
						eventType: 'ecrmLogined',
						// LGEITF-709 Start
						ecrmUserId: autoNvl(resultData.emailAddr),
						ecrmLocaleCode: autoNvl(resultData.localeCode),
						// LGEITF-709 End
						ecrmHostType: deviceTypeComm() // LGEITF-900
					}
				});
			};
			// LGEGMC-3469 End
			this.bakeCookie();
			setTimeout(function() {
				signinForm.submit();
			}, 100);
			
		},
		bakeCookie: function() { // Remember Email 체크시 쿠키 제어

			const signinForm = document.getElementById('signinForm'); 
			const $cookieCheckbox = $(signinForm).find('input.remember-account');
			const $emailAccount = $(signinForm).find('[name="emailAddr"]');
			const cookieName = 'LG5_RememberAccount' + '_' + $('html').data("countrycode") || "";
			if($cookieCheckbox.checked) {
				// bake account cookie
				const ac = xssfilter($emailAccount.get(0).value);
				setCookie(cookieName, ac);
			} else {
				removeCookie(cookieName);
			}

		},
		goToOtherPage: function( url ) { // 다른 페이지로 이동
			return location.href = url;
		},
		getCookieTd: function( name ) {
			if ($.cookie(name)) {
				return decodeURIComponent($.cookie(name));
			} else {
				$.cookie(name);
			}
		},
		treasuredataAjax: function( resultData ) {
			let treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/';
			treasuredataUrl += resultData.table+ '?';
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+this.tdClientIDCookie;
			treasuredataUrl += '&td_global_id='+this.tdGlobalID;
			treasuredataUrl += '&td_ssc_id='+this.tdSscID;

			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End

			//LGEGMC-4064 start
			if(cookieA && treasureDataFlag == 'Y'){
				$.ajax({
					url : treasuredataUrl,
					type : 'POST',
					dataType : 'jsonp',
					jsonpCallback: "callback",
					async: false,
					crossDomain: true,
					beforeSend: function (xhr) {
						xhr.setRequestHeader("Content-type","application/json");
						xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
					},
					success : function(data){
						// console.log(data);
						console.log('treasuredata post success'); // LGEIN-239
					}
				});
			}
			
			//LGEGMC-4064 start
			var treasuredataInsertParam = "";
			if(resultData.apikey)
				treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
			//LGEITF-767 start
			if(this.tdClientIDCookie)
				treasuredataInsertParam += '&td_client_id='+encodeURIComponent(this.tdClientIDCookie);
			if(this.tdGlobalID)
				treasuredataInsertParam += '&td_global_id='+encodeURIComponent(this.tdGlobalID);
			if(this.tdSscID)
				treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(this.tdSscID);
			//LGEITF-767 end
			if(resultData.timeSuccess)
				treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
			if(resultData.typeSuccess)
				treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
			if(resultData.typeLogin)
				treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
			if(resultData.typeSocial)
				treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
			if(resultData.lgeId)
				treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
			if(resultData.tdEmail)
				treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
			if(resultData.tdPhone)
				treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
			if(resultData.nameFirst)
				treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
			if(resultData.nameLast)
				treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
			if(resultData.sodialIdTwitter)
				treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
			if(resultData.screenNameTwitter)
				treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
			if(resultData.socialIdFb)
				treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
			if(resultData.nameFullFb)
				treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
			if(resultData.typeLoginResult)
				treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
			if(resultData.failMessage)
				treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
			if(resultData.localeCode)
				treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
			if(resultData.corporationCode)
				treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
			if(resultData.cdpNameCode)
				treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
			if(resultData.cdpName)
				treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
			if(resultData.tdTypeFail)
				treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
			if(resultData.noPhoneNameReason)
				treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
			if(resultData.database)
				treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
			if(resultData.table)
				treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
			treasureDataInsertTable(treasuredataInsertParam);
			//LGEGMC-4064 end

		},
		// Treasure Data Tracking ( type : Fail or loginAPI ) 
		treasuredataInit: function( resultData, type ) {
			const tdLoginStatus = new Treasure({
				host: 'eu01.in.treasuredata.com',
				writeKey: resultData.apikey,
				database: resultData.database,
				sscDomain: 'lg.com',
				sscServer: 'ssc.lg.com',
				useServerSideCookie: true
			});
			tdLoginStatus.setSignedMode();
			// Enable cross-domain tracking
			tdLoginStatus.set('$global', 'td_global_id', 'td_global_id');

			// Receive td_global_id
			const successCallback = function(td_global_id_data) {
				console.log('successCallback');
				this.tdGlobalID = td_global_id_data;
				this.tdClientIDCookie = snsSignin.getCookieTd('_td');
				snsSignin.treasuredataAjax(resultData);
			
				if(type == 'loginAPI'){
					snsSignin.signinByIDPW(resultData);
				// LGEITF-182 Start
				}else if(type == 'FAIL'){
					console.log('Treasure data Login Fail');
				}		
				// LGEITF-182 End
			};
			const errorCallback = function(err) {
				console.log('errorCallback');
				this.tdClientIDCookie = snsSignin.getCookieTd('_td');
				snsSignin.treasuredataAjax(resultData);
				
				if(type == 'loginAPI'){
					snsSignin.signinByIDPW(resultData);
				// LGEITF-182 Start
				}else if(type == 'FAIL'){
					console.log('Treasure data Login Fail');
				}		
				// LGEITF-182 End
			};
			const successCallback_ssc = function (serverSideId) {
				console.log('successCallback_ssc');
				this.tdSscID = serverSideId;
				tdLoginStatus.fetchGlobalID(successCallback, errorCallback);
			};
			const errorCallback_ssc = function (error) {
				console.log('errorCallback_ssc :: '+error);
			}
			tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc);
		},
		pageGoPost : function(_data) {
            var insdoc = "";
            for (var i = 0; i < _data.vals.length; i++) {
                insdoc += "<input type='hidden' name='" + _data.vals[i][0] + "' value='" + _data.vals[i][1] + "'>";
            }
            var goform = $("<form>", {
                method: "post",
                action: _data.url,
                target: _data.target,
                html: insdoc
            }).appendTo("body");
            goform.submit();
		},
        getSsoURLParams : function(url) {
            var result = {};
            url.replace(/[?&]{1}([^=&#]+)=([^&#]*)/g, function(s, k, v) { result[k] = decodeURIComponent(v); });
            return result;
        },
        //LGCOMITF-123-2 start
        nonTreasureDataInsertTable : function(resultData) {
			//LGEGMC-4064 start
			var treasuredataInsertParam = "";
			
			//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
			
			if(resultData.timeSuccess)
				treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
			if(resultData.typeSuccess)
				treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
			if(resultData.typeLogin)
				treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
			if(resultData.typeSocial)
				treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
			if(resultData.lgeId)
				treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
			if(resultData.tdEmail)
				treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
			if(resultData.tdPhone)
				treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
			if(resultData.nameFirst)
				treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
			if(resultData.nameLast)
				treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
			if(resultData.sodialIdTwitter)
				treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
			if(resultData.screenNameTwitter)
				treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
			if(resultData.socialIdFb)
				treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
			if(resultData.nameFullFb)
				treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
			if(resultData.typeLoginResult)
				treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
			if(resultData.failMessage)
				treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
			if(resultData.localeCode)
				treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
			if(resultData.corporationCode)
				treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
			if(resultData.cdpNameCode)
				treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
			if(resultData.cdpName)
				treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
			if(resultData.tdTypeFail)
				treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
			if(resultData.noPhoneNameReason)
				treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
			if(resultData.database)
				treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
			if(resultData.table)
				treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
			treasureDataInsertTable(treasuredataInsertParam);
			//LGEGMC-4064 end
        }
        //LGCOMITF-123-2 end
	}
	snsSignin.init();
	
	// Javascript용 SDK 설정
	const runSDK = function() {
		if(cookieA || treasureDataFlag != 'Y'){
			// facebook
			/* LGEUK-75 : 20200728 modify */
			if(window.fbOptions){
				(function(d, s, id){
					let js;
					const fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) {return;}
					js = d.createElement(s); js.id = id;
					js.src = "https://connect.facebook.net/"+ fbOptions.localeCode /* ex)ko_KR */+"/sdk.js";
					fjs.parentNode.insertBefore(js, fjs);
				}(document, 'script', 'facebook-jssdk'));

				window.fbAsyncInit = function() {
					FB.init(fbOptions);
					FB.AppEvents.logPageView();
					FB.getLoginStatus(function(response) {
					});
				};
			}
			/*// LGEUK-75 : 20200728 modify */

			// google 
			// LGEIN-239 Start
			if(window.ggOptions){
				(function(d, s, id){
					let js;
					const fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) {return;}
					js = d.createElement(s); js.id = id;
					js.src = "https://apis.google.com/js/api:client.js?onload=ggStartApp";
					fjs.parentNode.insertBefore(js, fjs);		
				}(document, 'script', 'google-jssdk'));
			}
			// LGEIN-239 End

			// apple 
			if(window.appleOptions){
				(function(d, s, id) {
					let js; 
					const fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return;
					js = d.createElement(s);
					js.id = id;
					js.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
					fjs.parentNode.insertBefore(js, fjs);
				}(document, 'script', 'apple-sdk'));
			}

			// amazon
			if(window.amzOptions){
				(function(d, s, id) {
					let js;
					const fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return;
					js = d.createElement('script'); 
					js.type = 'text/javascript';
					js.async = true;
					js.id = id;
					js.src = 'https://api-cdn.amazon.com/sdk/login1.js';
					fjs.parentNode.insertBefore(js, fjs);
		
					window.onAmazonLoginReady = function() {
						amazon.Login.setClientId(amzOptions.clientId); // set client ID
					};
				})(document, 'script', 'amazon-login-sdk');
			}

		}
	};
	runSDK();
	
	const appleDecoder = function (str) {
		let output = str.replace(/-/g, "+").replace(/_/g, "/");
		switch (output.length % 4) {
		case 0:
			break;
		case 2:
			output += "==";
			break;
		case 3:
			output += "=";
			break;
		default:
			throw "Illegal base64url string!";
		}

		try {
			return b64DecodeUnicode(output);
		} catch (err) {
			return atob(output);
		}
	}
});